import content from './../Translations/Registration';

export function emailValidation(lng, text) {
    if (text.length === 0) {
        return content[lng] ? content[lng].emailVal1 : content['en-EN'].emailVal1;
    }
    var re = /^([a-z0-9]+(?:(\.|_|-)[a-z0-9]+)*@(?:[a-z0-9]+(?:(-)[a-z0-9]+)?\.)+[a-z0-9](?:[a-z0-9]*[a-z0-9])?)$/i
    if (text.match(re)) {
        return true;
    } else {
        return content[lng] ? content[lng].emailVal1 : content['en-EN'].emailVal1;
    }
}

export function passwordValidation(lng, password) {
    if (password.length === 0) {
        return content[lng] ? content[lng].passVal1 : content['en-EN'].passVal1;
    }
    //if (password.length < 6) {
    //    return content[lng] ? content[lng].passVal2 : content['en-EN'].passVal2;
    //}
    if (password.match(/^[a-zA-Z0-9!@#$%&^*()_+\-=]{6,64}$/) === null) {
        return content[lng] ? content[lng].passVal3 : content['en-EN'].passVal3;
    }
    return true;
}

export function usernameValidation(lng, username, usernameValidationAPI = "") {
    if (username.length < 6) {
        return content[lng] ? content[lng].userVal1 : content['en-EN'].userVal1;
    }
    if (!username.match(/^[a-zA-Z0-9_]*$/)) {
        return content[lng] ? content[lng].userVal2 : content['en-EN'].userVal2;
    }
    if (username.match(/^\d{1,}/)) {
        return content[lng] ? content[lng].userVal3 : content['en-EN'].userVal3;
    }
    const url = !usernameValidationAPI ? `${pcashImliveURL}/XML/CheckLogin.asp?username=${username}` : `${usernameValidationAPI}?username=${username}`
    return fetch(url);
}